import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {CampaignNoteDto} from "../../model/dto/entity/campaign-note.dto";

@Injectable({
    providedIn: 'root'
})
export class CampaignNoteService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/campaignNotes')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-note-sticky';
    }

    /**
     * Gets all notes for a campaign.
     */
    getByCampaignId(campaignId: number, noteType?: string): Observable<CampaignNoteDto[]> {
        let suffix = `/byCampaign/${campaignId}`;
        if (noteType) {
            suffix += `?noteType=${noteType}`;
        }
        return this.getGeneric<CampaignNoteDto[]>(suffix);
    }

    /**
     * Gets all pinned notes for a campaign.
     */
    getPinnedNotes(campaignId: number): Observable<CampaignNoteDto[]> {
        return this.getGeneric<CampaignNoteDto[]>(`/byCampaign/${campaignId}/pinned`);
    }

    /**
     * Searches notes within a campaign.
     */
    searchNotes(campaignId: number, searchTerm: string): Observable<CampaignNoteDto[]> {
        return this.getGeneric<CampaignNoteDto[]>(`/byCampaign/${campaignId}/search?searchTerm=${encodeURIComponent(searchTerm)}`);
    }

    /**
     * Searches notes across all campaigns.
     */
    searchAllNotes(searchTerm: string): Observable<CampaignNoteDto[]> {
        return this.getGeneric<CampaignNoteDto[]>(`/search?searchTerm=${encodeURIComponent(searchTerm)}`);
    }

    /**
     * Toggles the pinned status of a note.
     */
    togglePin(noteId: number): Observable<CampaignNoteDto> {
        return this.postGeneric<CampaignNoteDto>({}, `/${noteId}/togglePin`);
    }
}
